import ExcelJS from "exceljs";

import { ARTICLE_TEMPLATE_COLUMNS } from "./articleImportSchema";

export { ARTICLE_TEMPLATE_COLUMNS } from "./articleImportSchema";

function styleHeader(sheet) {
  sheet.getRow(1).height = 30;
  sheet.getRow(1).eachCell(cell => {
    cell.font = { bold: true, color: { argb: "FF243746" } };
    cell.fill = { type: "pattern", pattern: "none" };
    cell.alignment = { vertical: "middle", wrapText: true };
  });
  sheet.views = [{ state: "frozen", ySplit: 1 }];
}

export function buildArticleImportTemplate(lookups) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Accountree";
  const articles = workbook.addWorksheet("Artikujt");
  articles.columns = ARTICLE_TEMPLATE_COLUMNS;
  styleHeader(articles);
  articles.autoFilter = "A1:J1";
  articles.getColumn("barcode").numFmt = "@";
  articles.getCell("A1").note = "Barkodi standard (8, 12, 13 ose 14 shifra) ruhet si tekst. Kodet jo standarde (p.sh. AC001, ACC001, 3242) zëvendësohen me barkodin ACC të radhës nga databaza; numri i shkruar nuk përdoret. Kur është bosh, gjenerohet nga seria ACC e kompanisë.";
  articles.getColumn("purchasePrice").numFmt = "0.00####";
  articles.getColumn("salesPrice").numFmt = "0.00####";
  // Reference names sit beside the input area; only columns A:J contain articles.
  articles.getColumn(11).width = 5;
  const specs = [
    ["Grupet", lookups.groups, "GroupID", "GroupName", true, "group", "FF2563EB"],
    ["Kategoritë", lookups.categories, "CategoryID", "CategoryName", true, "category", "FF8B5CF6"],
    ["Njësitë matëse", lookups.units.filter(unit => [true, 1, "1", "true"].includes(unit.IsGlobal)), "UnitID", "UnitName", true, "unit", "FF16803C"],
    ["TVSH", lookups.vatRates, "VATID", "VATName", true, "vat", "FFDB7800"],
    ["Njësitë organizative", lookups.companyUnits, "UnitID", "UnitName", false, null, "FF0891B2"],
  ];
  const missing = specs.filter(spec => spec[4] && !spec[1].length);
  if (missing.length) throw new Error(`Plotësoni listat në Accountree para shkarkimit: ${missing.map(spec => spec[0]).join(", ")}.`);
  specs.forEach(([title, rows, idKey, nameKey, required, target, color], index) => {
    const column = 12 + index;
    articles.getColumn(column).width = 32;
    articles.getColumn(column).numFmt = "@";
    const edge = { style: "thin", color: { argb: color } };
    const border = { top: edge, bottom: edge, left: edge, right: edge };
    articles.getColumn(column).border = border;
    if (target) articles.getColumn(target).border = border;
    articles.getCell(1, column).value = title;
    articles.getCell(1, column).note = "Kopjoni emrin e saktë në kolonën përkatëse të artikujve. Kjo listë shërben vetëm si referencë.";
    rows.forEach((row, i) => {
      const name = String(row[nameKey] || "").trim();
      if (!name || !Number.isInteger(Number(row[idKey])) || Number(row[idKey]) <= 0)
        throw new Error(`Vlerë e pavlefshme në listën: ${title}.`);
      // Keep the actual name, with no IDs or suffixes; resolve against live lists on import.
      articles.getCell(i + 2, column).value = name;
      articles.getCell(i + 2, column).font = { color: { argb: "FF243746" } };
    });
  });
  ["group", "category", "unit", "vat"].forEach(key => {
    articles.getColumn(key).numFmt = "@";
    articles.getCell(1, articles.getColumn(key).number).note = "Shkruani ose kopjoni emrin nga listat anash. Mund ta ngjitni në shumë rreshta njëherësh.";
  });
  styleHeader(articles);
  // Pair input and reference headers with colored borders, without backgrounds.
  specs.forEach(([, , , , , target, color], index) => {
    const columns = [12 + index];
    if (target) columns.push(articles.getColumn(target).number);
    columns.forEach(column => {
      const edge = { style: "medium", color: { argb: color } };
      articles.getCell(1, column).border = { top: edge, bottom: edge, left: edge, right: edge };
      articles.getCell(1, column).font = { bold: true, color: { argb: "FF243746" } };
    });
  });
  // Visible explanations on the same sheet, beside the reference lists.
  articles.getColumn(17).width = 5;
  articles.getColumn(18).width = 65;
  articles.getCell("R1").value = "Si plotësohen artikujt?";
  articles.getCell("R1").font = { bold: true, color: { argb: "FF243746" } };
  articles.getCell("R1").alignment = { wrapText: true, vertical: "middle" };
  const visibleInstructions = [
    ["Grupi: kopjoni emrin nga lista Grupet (L) në kolonën Grupi (D). Mos shkruani ID; përdorni emrin e saktë nga lista.", "FF2563EB"],
    ["Kategoria: kopjoni emrin nga lista Kategoritë (M) në kolonën Kategoria (E). Mos krijoni emërtim të ri në Excel.", "FF8B5CF6"],
    ["Njësia matëse: kopjoni emrin nga lista Njësitë matëse (N) në kolonën F, p.sh. Copë ose Kg, vetëm nëse figuron në listë. Kjo nuk është marketi/depoja.", "FF16803C"],
    ["TVSH: kopjoni emërtimin e plotë nga lista TVSH (O) në kolonën G. Mos shkruani vetëm përqindjen, përveç nëse ai është emërtimi në listë.", "FFDB7800"],
    ["Për shumë artikuj: ngjitni emrin në qelizën e parë, zgjidhni atë qelizë dhe qelizat poshtë saj, pastaj përdorni Fill Down në Excel.", "FF64748B"],
    ["Plotësoni vetëm kolonat A:J nga rreshti 2. Listat dhe këto sqarime anash nuk janë artikuj për importim. Kolonat me * janë të detyrueshme.", "FF64748B"],
    ["Barkodi standard me 8, 12, 13 ose 14 shifra ruhet pa ndryshim, përfshirë zerot në fillim. Kodet jo standarde (p.sh. AC001, ACC001, 3242) zëvendësohen me barkodin ACC të radhës nga databaza; numri i shkruar nuk përdoret. Lëreni bosh nëse dëshironi gjenerim nga seria ACC0000001… e kompanisë.", "FF64748B"],
  ];
  visibleInstructions.forEach(([text, color], index) => {
    const start = 2 + index * 4;
    articles.mergeCells(start, 18, start + 3, 18);
    const cell = articles.getCell(start, 18);
    cell.value = text;
    cell.font = { size: 11, color: { argb: "FF243746" } };
    cell.alignment = { wrapText: true, vertical: "middle" };
    const edge = { style: "thin", color: { argb: color } };
    cell.border = { top: edge, bottom: edge, left: edge, right: edge };
  });
  ["J"].forEach(column => articles.dataValidations.add(`${column}2:${column}1048576`, {
    type: "list", allowBlank: true, formulae: ['"Po,Jo"'], showErrorMessage: true,
    errorStyle: "stop", error: "Zgjidhni Po ose Jo.",
  }));
  ["H", "I"].forEach(column => articles.dataValidations.add(`${column}2:${column}1048576`, {
    type: "decimal", operator: "greaterThanOrEqual", allowBlank: column === "H", formulae: [0],
    showErrorMessage: true, errorStyle: "stop", error: "Çmimi duhet të jetë zero ose pozitiv.",
  }));
  const instructions = workbook.addWorksheet("Udhëzime");
  instructions.columns = [{ header: "Plotësimi i shabllonit", key: "text", width: 110 }];
  [
    "Plotësoni fletën Artikujt nga rreshti 2. Mos ndryshoni emrat e kolonave.",
    "Kolonat me * janë të detyrueshme. Grupi, kategoria, njësia matëse dhe TVSH-ja plotësohen si tekst, me emrat nga Accountree.",
    "Listat janë anash artikujve, në kolonat L:P. Kopjoni një emër, zgjidhni qelizat përkatëse të shumë artikujve dhe ngjiteni njëherësh.",
    "Ngjyrat e bordurave tregojnë lidhjen: Grupi dhe Grupet janë blu; Kategoria dhe Kategoritë vjollcë; Njësia matëse dhe lista e saj jeshile; TVSH dhe lista e saj portokalli. Emrat e kolonave tregojnë gjithashtu listën përkatëse.",
    "Grupi: kopjoni emrin nga lista Grupet anash dhe vendoseni në kolonën Grupi, p.sh. Pije, vetëm nëse figuron në listën tuaj.",
    "Kategoria: kopjoni emrin nga lista Kategoritë anash dhe vendoseni në kolonën Kategoria. Mos shkruani ID ose emër të ri.",
    "Njësia matëse: kopjoni emrin nga lista Njësitë matëse, p.sh. Copë ose Kg, saktësisht si figuron; kjo nuk është njësia organizative/marketi.",
    "TVSH: kopjoni emërtimin e plotë nga lista TVSH anash, jo ID-në ose vetëm përqindjen, përveç nëse vetë emërtimi është përqindje.",
    "Për shumë artikuj: kopjoni emrin nga lista, zgjidhni qelizat e kolonës përkatëse dhe përdorni Ctrl+D (Fill Down) pasi ta keni ngjitur në qelizën e parë, ose Paste për të gjithë përzgjedhjen.",
    "Lloji nuk plotësohet në Excel. Në tabelën e importimit do të nisë si Artikull i thjeshtë; alternativat janë Gjysëm Produkt dhe Produkt i Prodhuar.",
    "Barkodi është opsional në Excel. Barkodat standardë me 8, 12, 13 ose 14 shifra ruhen si tekst, me zerot në fillim. Çdo kod jo standard zëvendësohet me barkodin ACC të radhës nga databaza; numri i Excel-it nuk përdoret. Kur mungon, gjenerohet nga seria aktuale ACC e kompanisë. Kodet e tjera kërkojnë korrigjim.",
    "Çmimet janë me TVSH. Për çmimin e blerjes bosh do të përdoret 0.",
    "Aktiv pranon Po/Jo; kur është bosh do të përdoret Po.",
    "Shfaqja në POS nuk plotësohet në Excel. Në faqen e importimit do të caktohet me një zgjedhje për shumë artikuj njëherësh.",
    "Emërtimi: maksimumi 1000 karaktere. Përshkrimi: maksimumi 800 karaktere.",
    "Njësitë organizative do t'i zgjidhni në tabelë pas ngarkimit; një artikull mund të ketë disa njësi.",
    "Plotësoni vetëm kolonat A:J. Listat anash janë referencë dhe nuk janë artikuj për importim.",
    "Mos ndryshoni listat anash. Ato pasqyrojnë momentin e shkarkimit; emrat do të lidhen me ID-të aktuale gjatë importimit. Emrat e panjohur ose të paqartë do të kërkojnë korrigjim.",
    "Shkarkimi dhe plotësimi i shabllonit nuk ruajnë artikuj në databazë.",
  ].forEach(text => instructions.addRow({ text }));
  instructions.eachRow(row => { row.alignment = { wrapText: true, vertical: "middle" }; row.height = 36; });
  styleHeader(instructions);
  return workbook;
}
